import { ComponentType } from "react"
import { With } from "../common/componentExtensions"

import Store from "./tipiCaldaieStore"
import Actions from "./tipiCaldaieActions"

export let withTipiCaldaie = <TProps extends {}>(cmp: ComponentType<TProps>) => With(cmp, Store, () => Actions.getAll());